// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__3ALdz","cardSubTitle":"styles_cardSubTitle__3mT6H"};